




















import Vue from 'vue';
import Component from 'vue-class-component';
import * as types from '@/store/types';
import {mapGetters} from 'vuex';

@Component({
    computed: mapGetters({
        superadminPermissions: types.AUTH_HAS_SUPERADMIN_PERMISSIONS,
    })
})
export default class OfficesContainer extends Vue {
}
